import React__default from 'react';
import { __rest, __assign } from '../../../_virtual/_tslib.js';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import { feedbackRequestedRichCard } from '../../../services/richCardFactory.js';
import FeedbackRequestBusinessMessage from './FeedbackRequestBusinessMessage/index.js';
import FeedbackRequestConsumerMessage from './FeedbackRequestConsumerMessage/index.js';

var FeedbackRequestMessage = function FeedbackRequestMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;
  var richCard = feedbackRequestedRichCard(props.message);

  switch (application) {
    case Application.CONSUMER:
      return React__default.createElement(FeedbackRequestConsumerMessage, __assign({}, props, {
        richCard: richCard
      }));

    case Application.BUSINESS:
    case Application.OPERATIONS:
      return React__default.createElement(FeedbackRequestBusinessMessage, __assign({}, props, {
        richCard: richCard
      }));
  }
};

FeedbackRequestMessage.handlesMessage = function (message) {
  return !!feedbackRequestedRichCard(message);
};

export default FeedbackRequestMessage;
//# sourceMappingURL=index.js.map
